<script>
    export let show = false;
    export let title = "";
    export let additionalClass = "";
    $: if (show === true) showModal();
    $: if (show === false) hideModal();
    $: modalClass = show ? "modal fade in show" : "modal";

    import { portal } from "svelte-portal";
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();
    function close() {
        dispatch("close");
    }
    function showModal() {
        document.body.classList.add("modal-open");
    }
    function hideModal() {
        document.body.classList.remove("modal-open");
    }
</script>

{#if show}
    <div class="modal-backdrop fade in" use:portal />
{/if}

<div class={modalClass} tabindex="-1" role="dialog">
    <div class={`modal-dialog ${additionalClass}`} role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    on:click={close}
                    ><span aria-hidden="true">&times;</span></button
                >
                <h4 class="modal-title">{title}</h4>
            </div>
            <div class="modal-body">
                <slot />
            </div>
            <div class="modal-footer">
                <slot name="footer">
                    <button
                        type="button"
                        class="btn btn-default"
                        data-dismiss="modal"
                        on:click={close}>Close</button
                    >
                </slot>
            </div>
        </div>
    </div>
</div>

<style>
    .show {
        display: block;
    }
</style>
